<template>
    <AdminPageInner v-if="course.id" :breadcrumbs="breadcrumbs">
        <template #heading>Edit: {{ student.name }}'s attendance record</template>
        <CourseRecordForm @submit="onSubmit">
            <template #footer>
                <div class="flex flex-row-reverse items-center">
                    <SubmitButton
                        :submitting="form.processing"
                        :disabled="form.errors.any()">
                        {{ requiresSessionDates ? 'Next' : 'Update' }}
                    </SubmitButton>
                    <router-link :to="redirectRoute" class="text-gray-500 mr-4">
                        Cancel
                    </router-link>
                </div>
            </template>
        </CourseRecordForm>
    </AdminPageInner>
</template>

<script>

import axios from "axios";
import AdminPageInner from "@/Components/Layout/AdminPageInner";
import CourseRecordForm from "@/Pages/Admin/CourseRecords/Components/Form";
import SubmitButton from "@/Components/Form/SubmitButton";

export default {

    name: "CourseRecordEditPage",

    data() {
        return {
            course: {},
            form: this.$form(),
        }
    },

    provide() {
        return {
            form: this.form
        }
    },

    components: {
        AdminPageInner,
        CourseRecordForm,
        SubmitButton
    },

    methods: {
        setData({record, course}) {
            this.form.withData({
                attended: record.attended,
                feedback: record.feedback,
            });
            this.record = record;
            this.course = course;
        },
        onSubmit() {

            if (this.form.processing) {
                return;
            }

            this.form.put(route('api.course-records.update', this.record))
                .then(async record => {
                    this.$notify.success('Record updated');
                    await this.$router.push(this.redirectRoute);
                })
                .catch(console.error);
        },
    },

    computed: {
        breadcrumbs() {
            return [
                {
                    label: 'Admin', to: {name: 'admin'}
                },
                {
                    label: 'Courses', to: {name: 'admin.courses.index'}
                },
                {
                    label: `${this.course.title || 'Course'}`,
                    to: {name: 'admin.courses.show', params: {courseId: this.$route.params.courseId}}
                },
                {
                    label: `Session Groups`,
                    to: {name: 'admin.courses.session-groups.index', params: {courseId: this.$route.params.courseId}}
                },
                {
                    label: `Group`,
                    to: {
                        name: 'admin.courses.session-groups.show',
                        params: {
                            courseId: this.$route.params.courseId,
                            courseSessionGroupId: this.$route.params.courseSessionGroupId
                        }
                    }
                },
                {
                    label: `Records`, to: {
                        name: 'admin.courses.session-groups.sessions.records.index',
                        params: {
                            courseId: this.$route.params.courseId,
                            courseSessionGroupId: this.$route.params.courseSessionGroupId,
                            courseSessionId: this.$route.params.courseSessionId
                        }
                    }
                },
                {
                    label: `Record`, to: {
                        name: 'admin.courses.session-groups.sessions.records.show',
                        params: {
                            courseId: this.$route.params.courseId,
                            courseSessionGroupId: this.$route.params.courseSessionGroupId,
                            courseSessionId: this.$route.params.courseSessionId,
                            courseRecordId: this.$route.params.courseRecordId
                        }
                    }
                },
                {label: `Edit`, to: {name: this.$route.name, params: this.$route.params}},
            ];
        },
        redirectRoute() {
            return this.$route.meta.previous
                ? this.$route.meta.previous
                : {
                    name: 'admin.courses.session-groups.sessions.records.index',
                    params: {
                        courseId: this.$route.params.courseId,
                        courseSessionGroupId: this.$route.params.courseSessionGroupId,
                        courseSessionId: this.$route.params.courseSessionId
                    }
                };
        },
        student() {
            return this.record.application.student;
        },
    },

    async beforeRouteEnter(to, from, next) {
        const responses = await Promise.all([
            axios.get(route('api.course-records.edit', to.params.courseRecordId)),
            axios.get(route('api.courses.show', to.params.courseId)),

        ])

        const data = {
            record: responses[0].data,
            course: responses[1].data,

        };
        next(vm => vm.setData(data));
    },
};
</script>
